module.exports = __webpack_public_path__ + "static/media/sistemaPegar9.88fcf684.jpg";